module.exports = "/assets/js/b50ff3716968fe7a8f6808b772fbc3d7.svg";